import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8 17h-.06A1 1 0 008 19h.06A1 1 0 008 17zM24 17a1 1 0 101 1 1 1 0 00-1-1z"/><path d="M28.4 13.8L26 12l-.56-4.47a4 4 0 00-4-3.53H10.55a4 4 0 00-4 3.53L6 12l-2.4 1.8A4 4 0 002 17v5a2 2 0 002 2h1v2a2 2 0 002 2h2a2 2 0 002-2v-2h10v2a2 2 0 002 2h2a2 2 0 002-2v-2h1a2 2 0 002-2v-5a4 4 0 00-1.6-3.2zM8.72 7.67a2 2 0 012-1.67h10.59a2 2 0 012 1.67L24 12h-2a4 4 0 00.05-.5 3.5 3.5 0 00-7 0 4 4 0 00.05.5H8zM20 11.5a1.64 1.64 0 01-.09.5h-2.82a1.64 1.64 0 01-.09-.5 1.5 1.5 0 013 0zM9 26H7v-2h2zm16 0h-2v-2h2zm3-4H4v-5a2 2 0 01.8-1.6L6.67 14h18.66l1.87 1.4A2 2 0 0128 17z"/>';
export var CarOutlineSVG = function CarOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CarOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CarOutlineSVG);